<div class="modal-header">
  <h4 class="modal-title">
    {{ isWSIXMode ? ('exportToWSIXView.popup.title' | translate) : ('exportToWSCXView.popup.title' | translate) }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-6 col-form-label text-end" for="fileName">
          {{ isWSIXMode ? ('exportToWSIX.label.fileName' | translate) : ('exportToWSCX.label.fileName' | translate) }}:
        </label>
        <div class="col-md-6">
          <input class="form-control" type="text" id="fileName" formControlName="fileName" appInputAutoFocus
            [class.is-invalid]="form.controls.fileName.invalid && form.controls.fileName.touched">
          <div class="invalid-feedback">
            {{ form.controls.fileName.errors?.messageKey | translate:{'0':form.controls.fileName.errors?.param} }}
          </div>
        </div>
      </div>
      <div class="mb-3 row" *ngIf="saveOnServerPermission">
        <label class="col-md-6 text-end" for="saveOnServer">
          {{ isWSIXMode ? ('exportToWSIX.label.saveOnServer' | translate) : ('exportToWSCX.label.saveOnServer' | translate) }}:
        </label>
        <div class="col-md-6">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="saveOnServer" formControlName="saveOnServer">
            <label class="form-check-label" for="saveOnServer"></label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="export()" [disabled]="form.invalid">
    {{ isWSIXMode ? ('exportToWSIX.label.exportButton' | translate) : ('exportToWSCX.label.exportButton' | translate) }}
  </button>
</div>
